<template>
  <SectionFrame v-if="tiles.length || inStudio" :section="section" :index="index" :heading="heading" label="What do you need?">
    <ul v-if="tiles.length" :class="layout === 'list' ? 's2-tasks-list' : 's2-tasks'" class="mo-stagger">
      <li v-for="t in tiles" :key="t.label">
        <a :href="back(hrefFor(t))" class="t-card t-link s2-task" :data-dark="t.dark">
          <span v-if="t.icon" class="s2-task-icon" aria-hidden="true">{{ t.icon }}</span>
          <span class="s2-task-text"><b>{{ t.label }}</b><span v-if="t.note" class="s2-muted s2-small">{{ t.note }}</span></span>
          <span class="s2-task-go" aria-hidden="true">→</span>
        </a>
      </li>
    </ul>
    <StudioGap v-else>Add three to eight tasks people come to you for.</StudioGap>
  </SectionFrame>
</template>

<script setup>
import {computed} from "vue";
import SectionFrame from "./SectionFrame.vue";
import StudioGap from "./StudioGap.vue";
import {layoutOf, taskHref, taskTiles} from "@/utils/sectionLogic.js";
import {usePageStore} from "@/stores/pageStore";
import {studioMode} from "@/classes/previewBridge.js";
import {useBackLinks} from "@/composables/useBackLinks.js";
const back = useBackLinks();

const props = defineProps({section: {type: Object, required: true}, index: {type: Number, default: 0}});
const inStudio = computed(() => studioMode.value !== "off");
const layout = computed(() => layoutOf(props.section, ["tiles", "list"]));
const heading = computed(() => props.section.heading ?? "What do you need?");
const tiles = computed(() => taskTiles(props.section));
const pageStore = usePageStore();
// Get a quote with the tile's answer filled in, a page, or a call.
const hrefFor = (t) => taskHref(t, pageStore.pageData?.businessPhone?.number || "");
</script>

<style>
.s2-tasks { list-style: none; padding: 0; margin: 0; display: grid; gap: .9rem; grid-template-columns: repeat(auto-fill, minmax(220px, 1fr)); }
.s2-task { display: flex; align-items: center; gap: .9rem; height: 100%; box-sizing: border-box; min-height: 72px; transition: transform .15s ease; }
.s2-task:hover { transform: translateY(-2px); }
.s2-task:focus-visible { outline: 3px solid var(--t-accent); outline-offset: 2px; }
.s2-task[data-dark="true"] { background: var(--t-ink); color: var(--t-bg); }
.s2-task-icon { font-size: 1.4rem; width: 2.4rem; height: 2.4rem; display: inline-flex; align-items: center; justify-content: center; border-radius: var(--t-radius-sm);
  background: color-mix(in srgb, var(--t-accent) 14%, transparent); }
.s2-task-text { display: flex; flex-direction: column; flex: 1; }
.s2-task-go { opacity: .5; }
.s2-tasks-list { list-style: none; padding: 0; margin: 0; display: grid; gap: .5rem; max-width: 640px; }
@media (prefers-reduced-motion: reduce) { .s2-task { transition: none; } .s2-task:hover { transform: none; } }
</style>
